import React from 'react';

import { Pill } from '@/components/common/Pill';
import { IntakeStatus } from '@/services/types/intake-types';

import { getStatusVariant } from './statusVariantConfig';

/** Convert snake_case or Title Case → Title Case label. */
export const humanizeStatus = (raw: string): string => {
  const special: Record<string, string> = {
    [IntakeStatus.SENT_FOR_SIGNATURE]: 'Sent for Client Signature',
  };
  if (special[raw]) return special[raw];

  if (raw.includes(' ') && raw[0] === raw[0].toUpperCase()) {
    return raw;
  }

  return raw
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
};

/** Normalize various label variants to lowercase for color lookup. */
export const normalizeStatusKey = (value: string): string => {
  if (!value) return value;
  return String(value).trim().toLowerCase().replace(/\s+/g, '_');
};

interface StatusPillProps {
  /** Status string in any format (snake_case, Title Case, etc.) */
  status: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Unified status pill component for Intakes and Matters.
 * Uses configuration-driven status → color mapping from statusVariantConfig.ts.
 */
export const StatusPill: React.FC<StatusPillProps> = ({
  status,
  size = 'md',
  className = '',
}) => {
  const variant = getStatusVariant(status);
  const display = humanizeStatus(status);

  return (
    <Pill variant={variant} size={size} className={className}>
      {display}
    </Pill>
  );
};
